export const productFieldsFor = (projectDetails) => ({
  ...(projectDetails.lead?.homeownerInterest && { homeownerInterest: projectDetails.lead.homeownerInterest }),
  ...(projectDetails.productTracks && { productTracks: projectDetails.productTracks }),
});

const formatPreSalesProject = (projectDetails) => {
  const { id, upcomingStageNames, projectProgress, milestone } = projectDetails;
  const milestoneDisplayName = projectProgress.at(-1);

  return {
    projectId: id,
    ...productFieldsFor(projectDetails),
    upcomingStageNames,
    passedStageNames: projectProgress,
    milestoneDisplayName,
    milestone,
  };
};

export default formatPreSalesProject;
